
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  DatePicker,
} from 'antd';
import { MoneyField, SelectAjax } from 'Pages/DataGatewayPage/routerForm/utils';

import { BACKEND_URL_SOFTSEGUROS_RAMOS } from 'Config/routes';

import FormControl, { Select, FieldErrorMessage } from 'Components/commonComponents/FormControl';
// import { prepareDataForValidation } from 'formik';


const FormCreatePolice = ({ formController, loading, vendedores, selectedPackage }) => {
  
  useEffect(() => {
    if (vendedores.length == 1) formController.setFieldValue('vendedor', vendedores[0].id)
  }, [vendedores]);

  return <form>
    <Row style={{ marginBottom: '12px' }}>
      <Col span={12}>
        <Select
          showSearch
          filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          label="Vendedor"
          value={formController.values.vendedor}
          options={vendedores.map((vendedor) => ({ value: vendedor.id, label: vendedor.nombre }))}
          onChange={(value) => formController.setFieldValue('vendedor', value)}
          error={formController.errors.vendedor}
        />
      </Col>
      <Col span={12}>
        <span style={{ margin: 0 }}>Ramo</span>
        <SelectAjax
          value={formController.values.ramo}
          // handdleOnSearch={handdleOnSearchClient}
          placeholder="Ramo"
          urlRequest={`${BACKEND_URL_SOFTSEGUROS_RAMOS}list_softseguros_ramos/`}
          serializeResponse={(responseData) => {
            const serializedResults = responseData.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            return serializedResults;
          }}
          serializeParams={(inputSearchValue) => ({ texto_busqueda: inputSearchValue, aseguradora: selectedPackage.insurance_carrier })}
          onChange={(selectedOption) => formController.setFieldValue('ramo', selectedOption.value)}
        />
        {formController.errors.ramo && <FieldErrorMessage errorMessage={formController.errors.ramo} />}
      </Col>

      <Col span={12}>
        <FormControl
          name="numero_poliza"
          onChange={(e) => formController.setFieldValue('numero_poliza', e.target.value)}
          error={formController.errors.numero_poliza}
          placeholder="Número de póliza"
          label="Número de póliza"
          value={formController.values.numero_poliza}
          disabled={loading}
        />
      </Col>
      <Col span={12}>
        <FormControl
          name="codio_objeto_asegurado"
          onChange={(e) => formController.setFieldValue('codio_objeto_asegurado', e.target.value)}
          error={formController.errors.codio_objeto_asegurado}
          placeholder="Riesgo asegurado"
          label="Riesgo asegurado"
          value={formController.values.codio_objeto_asegurado}
          disabled
        />
      </Col>
    </Row>
    <Row style={{ marginBottom: '12px' }}>
      <Col span={12}>
        <FormControl
          FieldComponent={DatePicker}
          name="fecha_inicio"
          onChange={(newDate) => formController.setFieldValue('fecha_inicio', newDate)}
          error={formController.errors.fecha_inicio}
          placeholder="Fecha inicio"
          label="Fecha inicio"
          value={formController.values.fecha_inicio}
          disabled={loading}
        />
      </Col>
      <Col span={12}>
        <FormControl
          FieldComponent={DatePicker}
          name="fecha_fin"
          onChange={(newDate) => formController.setFieldValue('fecha_fin', newDate)}
          error={formController.errors.fecha_fin}
          placeholder="Fecha fin"
          label="Fecha fin"
          value={formController.values.fecha_fin}
          disabled={loading}
        />
      </Col>
    </Row>
    {/* <Divider>Información prima y comisiones</Divider> */}
    <Row style={{display: 'none'}}>
      <Col span={6}>
        <FormControl
          FieldComponent={MoneyField}
          name="prima"
          onChange={(newValue) => formController.setFieldValue('prima', newValue)}
          error={formController.errors.prima}
          placeholder="Prima"
          label="Prima"
          value={formController.values.prima}
        />
      </Col>
      <Col span={6}>
        <FormControl
          FieldComponent={MoneyField}
          name="gastos_expedicion"
          onChange={(newValue) => formController.setFieldValue('gastos_expedicion', newValue)}
          error={formController.errors.gastos_expedicion}
          placeholder="Gastos de expedición"
          label="Gastos de expedición"
          value={formController.values.gastos_expedicion}
        />
      </Col>
      <Col span={6}>
        <FormControl
          FieldComponent={MoneyField}
          name="iva"
          onChange={(newValue) => formController.setFieldValue('iva', newValue)}
          error={formController.errors.iva}
          placeholder="Iva"
          label="Iva"
          value={formController.values.iva}
        />
      </Col>
      <Col span={6}>
        <FormControl
          FieldComponent={MoneyField}
          name="total"
          onChange={(newValue) => formController.setFieldValue('total', newValue)}
          error={formController.errors.total}
          placeholder="Prima total"
          label="Prima total"
          value={formController.values.total}
        />
      </Col>
    </Row>
  </form>
};

FormCreatePolice.defaultProps = {
  loading: false,
  vendedores: [],
};

FormCreatePolice.propTypes = {
  loading: PropTypes.bool,
  vendedores: PropTypes.array,
  selectedPackage: PropTypes.shape({
    insurance_carrier: PropTypes.string,
  }).isRequired,
};

export default FormCreatePolice;
